module.exports = __webpack_public_path__ + "img/MCB-On.08d85d83.gif";